import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Button,
  Checkbox,
  Icon
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardEmployeeListUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0">
        <Form
          className="size small"
          id="CardEmployeeListUX-Form-1">
          <FormGroup
            id="CardEmployeeListUX-FormGroup-2">
            <FormField
              id="CardEmployeeListUX-FormField-3"
              width={3}>
              <label
                id="CardEmployeeListUX-label-12">
                Employee code
              </label>
              <Input
                fluid={true}
                id="CardEmployeeListUX-Input-13"
                name="code__icontains"
                onChange={props.onChangeFilter}
                value={props.filterEmployee?.code__icontains ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-4"
              width={3}>
              <label
                id="CardEmployeeListUX-label-14">
                Username
              </label>
              <Input
                fluid={true}
                id="CardEmployeeListUX-Input-18"
                name="user_employee__username__icontains"
                onChange={props.onChangeFilter}
                value={props.filterEmployee?.user_employee__username__icontains ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-5"
              width={3}>
              <label
                id="CardEmployeeListUX-label-15">
                Name
              </label>
              <Input
                fluid={true}
                id="CardEmployeeListUX-Input-19"
                name="first_name__icontains"
                onChange={props.onChangeFilter}
                value={props.filterEmployee?.first_name__icontains ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-6"
              width={3}>
              <label
                id="CardEmployeeListUX-label-16">
                Lastname
              </label>
              <Input
                fluid={true}
                id="CardEmployeeListUX-Input-20"
                name="last_name__icontains"
                onChange={props.onChangeFilter}
                value={props.filterEmployee?.last_name__icontains ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-7"
              width={3}>
              <label
                id="CardEmployeeListUX-label-17">
                Position
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                fluid={true}
                id="CardEmployeeListUX-Dropdown-21"
                name="position"
                onChange={props.onChangeFilter}
                options={props.positionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filterEmployee?.position ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-8"
              width={3}>
              <label
                id="CardEmployeeListUX-label-22">
                Affiliation
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                fluid={true}
                id="CardEmployeeListUX-Dropdown-23"
                name="affiliate"
                onChange={props.onChangeFilter}
                options={props.affiliateOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filterEmployee?.affiliate ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-9">
              <label
                id="CardEmployeeListUX-label-24">
                {"\u00A0"}
              </label>
              <div
                id="CardEmployeeListUX-div-25">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-10">
              <label
                id="CardEmployeeListUX-label-26">
                {"\u00A0"}
              </label>
              <Button
                color="green"
                icon={true}
                id="CardEmployeeListUX-Button-27"
                onClick={props.onAddEmployee}
                size="small"
                style={{display: "flex"}}>
                <Icon
                  id="CardEmployeeListUX-Icon-31"
                  name="user plus">
                </Icon>
                <label
                  id="CardEmployeeListUX-label-32"
                  style={{marginLeft: "6px"}}>
                  Employee
                </label>
              </Button>
            </FormField>
            <FormField
              id="CardEmployeeListUX-FormField-11"
              style={{transform: "scale(0.85)"}}>
              <label
                id="CardEmployeeListUX-label-30"
                style={{marginBottom: "0"}}>
                {"\u00A0"}
              </label>
              <Checkbox
                checked={props.filterEmployee?.show_inactive ?? false}
                id="CardEmployeeListUX-Checkbox-28"
                label="Include Inactive Employee"
                name="show_inactive"
                onChange={props.onChangeFilter}
                style={{margin: "0 0 0.35rem -1.5rem"}}>
              </Checkbox>
              <Checkbox
                checked={props.filterEmployee?.is_need_verify ?? false}
                id="CardEmployeeListUX-Checkbox-29"
                label="Need verification from HR"
                name="is_need_verify"
                onChange={props.onChangeFilter}
                style={{marginLeft: "-1.5rem"}}>
              </Checkbox>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeListUX-div-33">

          <Table
            data={props.tableData}
            getTrProps={props.getTrProps}
            headers="Employee code,Username,Prefix,Name,Lastname,Position,Affiliation,Status"
            id="CardEmployeeListUX-Table-34"
            keys="employee_code,username,prename,first_name,last_name,position_name,affiliation_name,status_name"
            minRows="15"
            showPagination={false}
            style={{height: "calc(-17.5rem + 100vh)"}}>
          </Table>
        </div>
        <div
          id="CardEmployeeListUX-div-35"
          style={{marginTop: "1rem", display: "flex", justifyContent: "flex-end"}}>
          {props.pagination}
        </div>
      </div>
    )
}


export default CardEmployeeListUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Mon Jun 23 2025 11:12:22 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-3"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-4"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-5"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-6"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-7"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-8"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-FormField-11"
        },
        "style": {
          "type": "code",
          "value": "{transform: \"scale(0.85)\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee code"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Input",
      "parent": 3,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Input-13"
        },
        "name": {
          "type": "value",
          "value": "code__icontains"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "value": {
          "type": "code",
          "value": "props.filterEmployee?.code__icontains ?? \"\""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Username"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Lastname"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "Position"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Input",
      "parent": 4,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Input-18"
        },
        "name": {
          "type": "value",
          "value": "user_employee__username__icontains"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "value": {
          "type": "code",
          "value": "props.filterEmployee?.user_employee__username__icontains ?? \"\""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Input",
      "parent": 5,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Input-19"
        },
        "name": {
          "type": "value",
          "value": "first_name__icontains"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "value": {
          "type": "code",
          "value": "props.filterEmployee?.first_name__icontains ?? \"\""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Input",
      "parent": 6,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Input-20"
        },
        "name": {
          "type": "value",
          "value": "last_name__icontains"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "value": {
          "type": "code",
          "value": "props.filterEmployee?.last_name__icontains ?? \"\""
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Dropdown",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Dropdown-21"
        },
        "name": {
          "type": "value",
          "value": "position"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.positionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterEmployee?.position ?? \"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "Affiliation"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Dropdown",
      "parent": 8,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Dropdown-23"
        },
        "name": {
          "type": "value",
          "value": "affiliate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.affiliateOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterEmployee?.affiliate ?? \"\""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-div-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-26"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Button",
      "parent": 10,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Button-27"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddEmployee"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Checkbox",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterEmployee?.show_inactive ?? false"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Checkbox-28"
        },
        "label": {
          "type": "value",
          "value": "Include Inactive Employee"
        },
        "name": {
          "type": "value",
          "value": "show_inactive"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 0 0.35rem -1.5rem\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Checkbox",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterEmployee?.is_need_verify ?? false"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Checkbox-29"
        },
        "label": {
          "type": "value",
          "value": "Need verification from HR"
        },
        "name": {
          "type": "value",
          "value": "is_need_verify"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"-1.5rem\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-30"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Icon",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Icon-31"
        },
        "name": {
          "type": "value",
          "value": "user plus"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-div-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 34,
      "name": "Table",
      "parent": 33,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "Employee code,Username,Prefix,Name,Lastname,Position,Affiliation,Status"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-Table-34"
        },
        "keys": {
          "type": "value",
          "value": "employee_code,username,prename,first_name,last_name,position_name,affiliation_name,status_name"
        },
        "minRows": {
          "type": "value",
          "value": "15"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(-17.5rem + 100vh)\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeListUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 35,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
